module.exports = __webpack_public_path__ + "img/internal_stock.a02ef269.svg";